import { useAttendeeChatBot } from '@bizzabo/ada-chatbot';
import config from 'config';
import Cookie from 'js-cookie';

import { UserData, Event } from '@bizzabo/entities';

export const useAda = (user: UserData, event: Event, isLoggedInUser: boolean) => {
    const authCookieAccessName = event?.groupId
        ? `${config.authCookieAccess}-${event?.groupId}`
        : '';
    const accessToken = Cookie.get(authCookieAccessName);

    const { isChatEnabled } = useAttendeeChatBot({
        attendee: user,
        isLoggedInUser,
        event,
        isFeatureEnabled: Number.isInteger(event?.groupId),
        realtimeNotificationsHost: config.realtimeNotificationsHost,
        dashboardUrl: config.dashboardUrl,
        apiServerUrl: config.baseUrl,
        authToken: accessToken,
        tokenCookieName: authCookieAccessName,
    });

    return isChatEnabled;
};
